import type {BroadcastSuppressionPhoneDetails} from 'src/components/messaging/broadcast-suppression/types';


export const getIgnorePhoneNumbersWithReason = (
  ignorePhoneNumberList: string[],
  phoneTypes: Record<string, BroadcastSuppressionPhoneDetails>,
) => {
  return ignorePhoneNumberList
    .map((phoneNumber) => {
      let reason = '';
      if (phoneNumber && phoneTypes?.[phoneNumber]?.optedOut) {
        reason = 'opted_out';
      } else if (phoneNumber && phoneTypes?.[phoneNumber]?.activePlacement) {
        reason = 'active_placement';
      } else if (
        phoneNumber &&
        phoneTypes?.[phoneNumber]?.type === 'landline'
      ) {
        reason = 'landline';
      } else if (phoneNumber && phoneTypes?.[phoneNumber]?.type === 'invalid') {
        reason = 'invalid';
      }
      return {phoneNumber, reason};
    })
    .filter((item) => item.reason !== '');
};
